module.exports = __webpack_public_path__ + "static/media/vn.722ba507.png";